import $ from "jquery";
let Metrics;

let url_to_array;

Metrics = require("../helpers/metrics").default;

url_to_array = require("../helpers/url_to_array").default;

class Settings {
    constructor(props) {
        let $billing_history;
        $billing_history = $("#billing-history");
        if (url_to_array[6] !== void 0) {
            if (url_to_array[6].split("show-billing=")[1] === "true") {
                $billing_history.toggleClass("hidden");
                $(".toggle-billing-history span").toggleClass("hidden");
                $("html, body").animate(
                    {
                        scrollTop: $("#billing-history").offset().top
                    },
                    700
                );
            }
        }
        $(document).ready(() => {
            let changeUsername;
            let changeUsernameInput;
            let changeUsernameLabel;
            let changeUsernameLoading;
            let changeUsernameSave;
            let checkUsernameAvailability;
            let checkUsernameTimer;
            let editUsername;
            let existingUsername;
            let form;
            let submitted;
            changeUsername = $(".username-change");
            changeUsernameInput = changeUsername.find("input");
            changeUsernameLabel = changeUsername.find("label");
            changeUsernameLoading = changeUsername.find(".loading");
            changeUsernameSave = changeUsername.find(".submit-username-change");
            changeUsername.find("label").on("click", e => editUsername(e));
            existingUsername = $(".user-permalink").attr("data-username");
            $(".edit-username").on("click", e => editUsername(e));
            editUsername = e => {
                e.preventDefault();
                changeUsernameInput.prop("disabled", "");
                changeUsernameInput.trigger("focus");
                changeUsernameSave.show();
                changeUsername.find(".submit-username-change").show();
                changeUsername.find(".edit-username").hide();
                return changeUsername.find(".edit-username-escape").show();
            };
            $(".edit-username-escape").on("click", e => {
                let stopCheckUsernameTimer;
                e.preventDefault();
                changeUsernameInput
                    .removeClass("error")
                    .attr("disabled", "disabled")
                    .val("");
                changeUsername.find(".edit-username-escape").hide();
                changeUsername.find(".submit-username-change").hide();
                changeUsername.find(".edit-username").show();
                changeUsernameLoading.removeClass("saving").hide();
                changeUsernameLabel.removeClass(
                    "error taken checking available"
                );
                stopCheckUsernameTimer = () => clearTimeout(checkUsernameTimer);
                return stopCheckUsernameTimer();
            });
            checkUsernameTimer = void 0;
            changeUsernameInput.on("keyup", function(e) {
                let stopCheckUsernameTimer;
                let value;
                changeUsernameSave.hide();
                changeUsernameLabel
                    .addClass("checking")
                    .removeClass("error available")
                    .text("Username");
                value = $(this).val();
                stopCheckUsernameTimer = () => clearTimeout(checkUsernameTimer);
                stopCheckUsernameTimer();
                if (value.length > 3) {
                    return (checkUsernameTimer = setTimeout(() => {
                        console.log(`timer time ${value}`);
                        return checkUsernameAvailability(value);
                    }, 2000));
                }
            });
            checkUsernameAvailability = theUsername => {
                changeUsernameLoading.show();
                return $.ajax({
                    url: `/${existingUsername}/settings/basics/check_username/`,
                    method: "POST",
                    data: {
                        username: theUsername
                    },
                    success(data, status, xhr) {
                        console.log(data);
                        if (data.availability) {
                            changeUsernameLabel
                                .removeClass("taken error")
                                .addClass("available");
                            changeUsernameLabel.removeClass("checking");
                            changeUsernameSave.show();
                            return changeUsernameLoading.hide();
                        } else {
                            changeUsernameLoading.hide();
                            changeUsernameLabel
                                .addClass("taken error")
                                .removeClass("available");
                            changeUsernameLabel.text("Username not available");
                            return changeUsernameInput.addClass("error");
                        }
                    }
                });
            };
            $(".submit-username-change").on("click", e => {
                let currentUsername;
                let username;
                e.preventDefault();
                changeUsernameSave.hide();
                changeUsernameLoading.addClass("saving").show();
                currentUsername = changeUsernameInput.attr("placeholder");
                console.log(`currentUsername${currentUsername}`);
                username = $(".username-change input").val();
                return $("#username-form").trigger("submit");
            });
            $(".progress .ui_down-triangle").on("click", function(e) {
                e.preventDefault();
                $("html").on("click", e => {
                    $(".progress .ui_down-triangle").toggleClass("reverse");
                    return $(".progress .drop-down ul").toggleClass("visible");
                });
                event.stopPropagation();
                $(this).toggleClass("reverse");
                return $(".progress .drop-down ul").toggleClass("visible");
            });
            $(".plan-select .current").on("click", e => {
                e.preventDefault();
                $("html").one("click", e =>
                    $(".plan-select > li").toggleClass("visible")
                );
                event.stopPropagation();
                return $(".plan-select > li").toggleClass("visible");
            });
            $(".plan-select .plan").on("click", function(e) {
                let $this;
                let modal;
                let newPlan;
                let newPrice;
                let selectedPlan;
                e.preventDefault();
                $this = $(this);
                modal = $(".modal.upgrade_modal");
                newPlan = $this.attr("data-plan");
                $("#plan-type").val(newPlan);
                newPrice = $this.attr("data-price");
                selectedPlan = $(".plan-select .current");
                if (newPlan === "enterprise_lead") {
                    newPlan = "enterprise";
                }
                selectedPlan.find("i").attr("class", `ui_${newPlan}`);
                selectedPlan.find(".current-plan").text(newPlan);
                if ($this.hasClass("my-plan")) {
                    $(".upcoming-invoice").show();
                } else {
                    $(".upcoming-invoice").hide();
                }
                modal.find("#new-plan-icon").attr("class", `ui_${newPlan}`);
                modal.find("#new-plan-name").text(newPlan);
                modal.find("#new-plan-price").text(newPrice);
                return modal.find("button").attr("data-plan-name", newPlan);
            });
            $(".close-modal").on("click", e => {
                let modal;
                e.preventDefault();
                modal = $(".modal.upgrade_modal");
                modal.removeClass("visible");
                return modal.find("#upgrade_modal_color").attr("class", "");
            });
            $(".step-1 input").on("click", e => {
                let explaination;
                $(".step-1b").removeClass("hidden");
                explaination = $("#explaination");
                explaination.on("focus");
                return $("html,body").animate(
                    {
                        scrollTop: explaination.offset().top
                    },
                    1000
                );
            });
            form = $(".step-1");
            submitted = false;
            $("#downgrade-action").on("click", e => {
                new Metrics().downgrade(form.data("user-id"));
                if (submitted === false) {
                    submitted = true;
                    return form.trigger("submit");
                }
            });
            $("#downgrade-action-link").on("click", function(e) {
                e.preventDefault();
                return $(this)
                    .parents("form")
                    .trigger("submit");
            });
            return $(".an-email-address button").on("click", function(e) {
                return $(this)
                    .parents("li")
                    .find("input[type=radio]")
                    .prop("checked", true);
            });
        });
        $("body").on("click", ".love-you", function(e) {
            e.preventDefault();
            return $(this)
                .clone()
                .insertAfter($(this));
        });
    }
}

export default Settings;
